import { type EntityId, type EntityType } from "./admin/types";

export const adminEntityTagsQueryKey = (entityType?: EntityType, entityId?: EntityId) =>
	entityType && entityId
		? (["admin", "entityTags", entityType, entityId] as const)
		: (["admin", "entityTags"] as const);
